import type { TeamMember } from '@easyhelp/shared';
import { useMemberMcpConnections, useRevokeMemberMcpConnection } from '../../../api/mcp-connections';
import { McpConnectionsPanel } from '../../../components/mcp';

export interface MemberMcpConnectionsProps {
  member: TeamMember;
  /** Esito della revoca, per lo Snackbar della pagina. */
  onRevoked: (message: string) => void;
}

/**
 * Connessioni di Claude e Cursor di un membro, aperte dalla sua riga in Impostazioni › Team
 * (PRD-007 US-2, #152): l'elenco si legge quando la riga si apre.
 */
export function MemberMcpConnections({ member, onRevoked }: MemberMcpConnectionsProps) {
  const query = useMemberMcpConnections(member.id);
  const revoke = useRevokeMemberMcpConnection(member.id);
  return (
    <McpConnectionsPanel
      owner={{ kind: 'member', name: member.name }}
      query={query}
      revoke={revoke}
      onRevoked={onRevoked}
    />
  );
}
